/**
 *
 * utils
 *
 */
/** @private */
export function isObject(val) {
    return typeof val === 'object' && val !== null;
}
